module.exports = __webpack_public_path__ + "static/img/frontpage5.117259b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/frontpage5.jpg
// module id = Qh2p
// module chunks = 0